import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    isInitialized: false,
    errorMessage: null,
    pageTitle: null
  }),
  mutations: {
    setInitialized(state) {
      state.isInitialized = true;
    },
    setErrorMessage(state, payload) {
      state.errorMessage = payload;
    },
    setPageTitle(state, payload) {
      state.pageTitle = payload;
    }
  },
  actions: {
    initialize(context) {
      axios.get("sanctum/csrf-cookie").then(() => {
        Promise.all([
          context.dispatch("user/setUser", null, { root: true })
        ]).then(() => {
          context.commit("setInitialized");
        });
      });
    },
    flashError(context, message) {
      context.commit("setErrorMessage", message || "Eek! There was an error");

      setTimeout(() => {
        context.commit("setErrorMessage", null);
      }, 3000);
    },
    setPageTitle(context, title) {
      document.title = title ? title + " | NOSCOPE ³⁶⁰" : "NOSCOPE ³⁶⁰";
      context.commit("setPageTitle", title);
    }
  },
  getters: {}
};
